import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, Users, BadgeCheck, Bookmark, Calendar, Settings, Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Avatar } from "@/components/Avatar";
import { VerifiedBadge } from "@/components/VerifiedBadge";
import { useUI } from "@/components/Layout";

const items = [
  { icon: Home, label: "Feed", to: "/" },
  { icon: Users, label: "Friends", to: "/friends" },
  { icon: Bookmark, label: "Saved", to: "/" },
  { icon: Calendar, label: "Events", to: "/" },
];

export default function LeftSidebar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { openVerify } = useUI();

  return (
    <div className="space-y-4">
      <button
        data-testid="sidebar-profile-btn"
        onClick={() => navigate(`/profile/${user.user_id}`)}
        className="w-full flex items-center gap-3 p-3 rounded-2xl bg-card border border-border hover:border-[#6C0BA9]/50 transition-all text-left"
      >
        <Avatar user={user} size={44} />
        <div className="min-w-0">
          <div className="font-semibold text-sm flex items-center gap-1 truncate">{user?.name}{user?.verified && <VerifiedBadge size={14} />}</div>
          <div className="text-xs text-muted-foreground">View your profile</div>
        </div>
      </button>

      <nav className="bg-card border border-border rounded-2xl p-2">
        {[...items, { icon: Settings, label: "Settings", to: "/settings" }, ...(user?.is_admin ? [{ icon: Shield, label: "Moderation", to: "/admin" }] : [])].map((it) => (
          <button
            key={it.label}
            data-testid={`sidebar-nav-${it.label.toLowerCase()}`}
            onClick={() => navigate(it.to)}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-accent transition-colors text-left text-sm font-medium"
          >
            <it.icon className="w-5 h-5 text-[#C084FC]" />
            {it.label}
          </button>
        ))}
      </nav>

      {!user?.verified && (
        <button
          data-testid="sidebar-verify-btn"
          onClick={openVerify}
          className="w-full text-left p-4 rounded-2xl border-2 border-[#6C0BA9]/50 bg-gradient-to-br from-[#6C0BA9]/20 to-[#E024A3]/10 hover:border-[#6C0BA9] transition-all group"
        >
          <div className="flex items-center gap-2 mb-1">
            <BadgeCheck className="w-5 h-5 text-[#C084FC] group-hover:scale-110 transition-transform" />
            <span className="font-heading font-bold text-sm">Get Verified</span>
          </div>
          <p className="text-xs text-muted-foreground">Stand out with a glowing badge for just $4/month.</p>
        </button>
      )}
    </div>
  );
}
